module.exports = __webpack_public_path__ + "img/uhive-logo-side-bar.566f608a.svg";